import { render, staticRenderFns } from "./OrgHeader.vue?vue&type=template&id=7fc9e2e2&scoped=true&lang=pug&"
import script from "./OrgHeader.vue?vue&type=script&lang=js&"
export * from "./OrgHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrgHeader.vue?vue&type=style&index=0&id=7fc9e2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc9e2e2",
  null
  
)

export default component.exports